/**
 *<p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019年01月29日</li>
 * <li>@author     : ____′↘夏悸</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import common from './common'
import system from './system'
import classPhoto from './classPhoto'
import classType from './classType'
import student from './student'
import course from './course'
import collect from './collect'
import clue from './clue'
import chapter from './chapter'
import question from './question'
import courseGroup from './courseGroup'
import pay from './pay'
import warehouse from './warehouse'
import user from './user'
import applet from './applet'
import allocation from './allocation'
import teaching from './teaching'
import courseWare from './courseWare'
import expend from './expend'
import plvyo from './plvyo'
import online from './online'
import activity from './activity'
import memberPoint from './memberPoint'
import Point from './point'
import webClazz from './webClazz'
import special from './special'
import weichat from './weichat'

import  Graduate from './Graduate'
import company from "@/api/company";
export const Course = require('./course').default;

export default {
	common,
	system,
	classType,
	classPhoto,
	student,
	course,
	collect,
	clue,
	chapter,
	question,
	courseGroup,
	pay,
	warehouse,
	user,
	allocation,
	applet,
	teaching,
	courseWare,
	expend,
	plvyo,
	online,
	activity,
	memberPoint,
	Point,
	webClazz,
	Graduate,
	weichat,
	company,
	special
}
